import React, { useEffect, useState } from 'react';
import './DropBallAnimation.css';

interface DropBallAnimationProps {
  onComplete: () => void;
}

const DropBallAnimation: React.FC<DropBallAnimationProps> = ({ onComplete }) => {
  const [animationPhase, setAnimationPhase] = useState<'rolling' | 'crushing' | 'complete'>('rolling');

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setAnimationPhase('crushing');
    }, 1500);

    const timer2 = setTimeout(() => {
      setAnimationPhase('complete');
      setTimeout(() => {
        onComplete();
      }, 500);
    }, 3000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onComplete]);

  return (
    <div className="drop-ball-animation-overlay">
      <div className="drop-ball-animation-container">
        <svg className="drop-ball-animation-svg" viewBox="0 0 900 400">
          {/* Mountain background */}
          <defs>
            <linearGradient id="animSkyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#87CEEB', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#E0F6FF', stopOpacity: 1 }} />
            </linearGradient>
            <linearGradient id="animGroundGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#9B8B75', stopOpacity: 0.9 }} />
              <stop offset="100%" style={{ stopColor: '#7B6B55', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          
          <rect width="900" height="400" fill="url(#animSkyGradient)" />
          
          <path
            d="M 50 360 Q 200 310 400 260 Q 600 210 850 160 L 900 160 L 900 400 L 0 400 Z"
            fill="url(#animGroundGradient)"
          />

          {/* Stickman */}
          <g className={`stickman-animation ${animationPhase === 'crushing' ? 'crushed' : ''}`}>
            <circle cx="450" cy="200" r="5" fill="#FFDBAC" stroke="#2c3e50" strokeWidth="2" />
            <line x1="450" y1="205" x2="450" y2="230" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" />
            <line x1="450" y1="215" x2="440" y2="220" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" />
            <line x1="450" y1="215" x2="460" y2="220" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" />
            <line x1="450" y1="230" x2="445" y2="250" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" />
            <line x1="450" y1="230" x2="455" y2="250" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" />
          </g>

          {/* Boulder rolling down */}
          <g className={`boulder-animation ${animationPhase}`}>
            <circle
              cx="490"
              cy="200"
              r="25"
              fill="#5A5A5A"
              stroke="#2c3e50"
              strokeWidth="2"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                dur="1.5s"
                values="0 490 200;360 490 200"
                repeatCount="indefinite"
              />
            </circle>
            <ellipse cx="485" cy="195" rx="5" ry="4" fill="#3A3A3A" opacity="0.6" />
            <ellipse cx="495" cy="205" rx="4" ry="3" fill="#4A4A4A" opacity="0.5" />
            <ellipse cx="490" cy="200" rx="3" ry="2" fill="#4A4A4A" opacity="0.5" />
          </g>

          {/* Crushed stickman (shown after crushing) */}
          {animationPhase === 'crushing' && (
            <g className="crushed-stickman">
              <line x1="450" y1="200" x2="440" y2="210" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
              <line x1="450" y1="200" x2="460" y2="210" stroke="#2c3e50" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
              <circle cx="450" cy="200" r="3" fill="#FFDBAC" opacity="0.5" />
              <text x="450" y="220" textAnchor="middle" fill="#e74c3c" fontSize="20" fontWeight="bold">💀</text>
            </g>
          )}

          {/* "OUCH!" text */}
          {animationPhase === 'crushing' && (
            <text
              x="450"
              y="180"
              textAnchor="middle"
              fill="#e74c3c"
              fontSize="30"
              fontWeight="bold"
              className="ouch-text"
            >
              OUCH!
            </text>
          )}
        </svg>
      </div>
    </div>
  );
};

export default DropBallAnimation;

